
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import HandleWarning from "../../../store/entities/handlewarning";
@Component
export default class SeeHandlewarnings extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  handleWarning: HandleWarning = new HandleWarning();
  close() {
     (this.$refs.handlewarningForm as any).resetFields();
    this.$emit("input", false);
    }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.handleWarning = Util.extend(true, {}, this.$store.state.thhandlewarning.seeHandlewarnings);
    }
  }
   handlewarningRule = {
    hContent: [{ required: true, message: "请输入处理内容", trigger: "blur" }],
  };
}
